export const navbarLinks = [
  { label: '首页', href: '/' },
  { label: '分类', href: '/category' },
  { label: '排行榜', href: '/' },
  { label: '最新上架', href: '/' },
  { label: '关于我们', href: '/about' },
];

export const heroData = {
  titleLine1: '探索最精彩的',
  titleLine2: '韩国漫画世界',
  titleLine3: '尽在韩漫网',
  subtitle: '海量高清韩漫免费看，每日更新，沉浸式阅读体验，随时随地追更你喜爱的韩国漫画作品。',
  ctaText: '开始阅读',
  ctaLink: '/category',
  sideTitle: '本周热门推荐',
  sideLink: '/',
};

export const popularComics = [
  {
    id: 1,
    title: '绝世神医',
    chapter: '更新至第128话',
    tag: '热门',
    tagColor: 'primary',
    image: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20cover%20art%20style%20illustration%20of%20a%20handsome%20male%20doctor%20in%20traditional%20hanbok%20with%20modern%20twist%2C%20holding%20a%20golden%20acupuncture%20needle%2C%20dramatic%20lighting%2C%20soft%20warm%20gradient%20background%20with%20cherry%20blossom%20petals%2C%20romance%20and%20drama%20theme%2C%20digital%20art%20style%20with%20rich%20colors%20and%20detailed%20facial%20features%2C%20vertical%20composition%2C%20clean%20and%20elegant%20aesthetic&width=600&height=800&seq=comic-cover-01&orientation=portrait',
  },
  {
    id: 2,
    title: '暗夜王者',
    chapter: '更新至第95话',
    tag: '新番',
    tagColor: 'accent',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20featuring%20a%20mysterious%20dark-haired%20man%20in%20a%20luxurious%20black%20suit%2C%20standing%20in%20a%20modern%20city%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20dramatic%20shadows%2C%20action%20and%20thriller%20theme%2C%20digital%20illustration%20with%20moody%20atmosphere%2C%20vertical%20orientation%2C%20clean%20composition%20with%20soft%20background&width=600&height=800&seq=comic-cover-02&orientation=portrait',
  },
  {
    id: 3,
    title: '甜蜜陷阱',
    chapter: '更新至第67话',
    tag: '人气',
    tagColor: 'primary',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20art%20of%20a%20lovely%20young%20woman%20with%20long%20flowing%20hair%2C%20wearing%20a%20pastel%20pink%20dress%2C%20surrounded%20by%20floating%20heart%20shapes%20and%20soft%20sparkles%2C%20romantic%20comedy%20theme%2C%20gentle%20warm%20lighting%20with%20pink%20and%20peach%20tones%2C%20digital%20art%20style%2C%20vertical%20composition%2C%20dreamy%20and%20sweet%20atmosphere&width=600&height=800&seq=comic-cover-03&orientation=portrait',
  },
  {
    id: 4,
    title: '剑道至尊',
    chapter: '更新至第203话',
    tag: '连载',
    tagColor: 'secondary',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20powerful%20swordsman%20in%20traditional%20martial%20arts%20attire%2C%20holding%20a%20glowing%20sword%2C%20standing%20on%20a%20mountain%20peak%20with%20dramatic%20clouds%20and%20sunset%20sky%2C%20action%20and%20cultivation%20theme%2C%20epic%20scale%2C%20digital%20art%20with%20vibrant%20warm%20colors%2C%20vertical%20orientation%2C%20clean%20and%20heroic%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait',
  },
  {
    id: 5,
    title: '办公室罗曼史',
    chapter: '更新至第42话',
    tag: '推荐',
    tagColor: 'primary',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20of%20an%20elegant%20office%20couple%2C%20man%20and%20woman%20in%20stylish%20business%20attire%2C%20standing%20back%20to%20back%20with%20soft%20smiles%2C%20modern%20office%20background%20with%20warm%20sunlight%20streaming%20through%20windows%2C%20romance%20drama%20theme%2C%20digital%20illustration%20with%20soft%20colors%2C%20vertical%20composition%2C%20clean%20and%20sophisticated%20style&width=600&height=800&seq=comic-cover-05&orientation=portrait',
  },
  {
    id: 6,
    title: '灵异侦探社',
    chapter: '更新至第58话',
    tag: '精品',
    tagColor: 'accent',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20mysterious%20detective%20with%20piercing%20eyes%2C%20wearing%20a%20long%20trench%20coat%2C%20holding%20a%20glowing%20lantern%20in%20a%20foggy%20alleyway%2C%20supernatural%20and%20mystery%20theme%2C%20cool%20blue-gray%20tones%20with%20warm%20lantern%20glow%2C%20digital%20art%20style%2C%20vertical%20orientation%2C%20atmospheric%20and%20suspenseful%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait',
  },
  {
    id: 7,
    title: '重生之商业帝国',
    chapter: '更新至第156话',
    tag: '热读',
    tagColor: 'primary',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20of%20a%20confident%20businessman%20in%20a%20tailored%20suit%2C%20standing%20in%20front%20of%20a%20modern%20skyscraper%2C%20golden%20hour%20lighting%2C%20success%20and%20ambition%20theme%2C%20digital%20illustration%20with%20warm%20golden%20tones%2C%20vertical%20composition%2C%20clean%20and%20powerful%20aesthetic&width=600&height=800&seq=comic-cover-07&orientation=portrait',
  },
  {
    id: 8,
    title: '魔法学徒日记',
    chapter: '更新至第89话',
    tag: '奇幻',
    tagColor: 'secondary',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20young%20magic%20student%20with%20spell%20books%20floating%20around%2C%20magical%20sparks%20and%20runes%20glowing%2C%20fantasy%20academy%20background%20with%20ancient%20library%2C%20adventure%20and%20magic%20theme%2C%20digital%20art%20with%20warm%20magical%20glow%2C%20vertical%20orientation%2C%20enchanting%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
  },
];

export const platformStats = [
  { value: '12,800', suffix: '+', label: '漫画作品' },
  { value: '3,500', suffix: '+', label: '活跃作者' },
  { value: '860', suffix: '万+', label: '月活跃读者' },
];

export const categoryEntries = [
  {
    id: 'romance',
    title: '恋爱',
    subtitle: '甜蜜浪漫的爱情故事',
    style: 'dark',
    icon: 'ri-heart-line',
    image: '',
  },
  {
    id: 'fantasy',
    title: '奇幻',
    subtitle: '魔法与冒险的幻想世界',
    style: 'image',
    icon: 'ri-magic-line',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20fantasy%20Korean%20manhwa%20scene%2C%20magical%20floating%20islands%20with%20ancient%20temples%2C%20glowing%20crystals%20and%20ethereal%20light%2C%20soft%20mist%2C%20dreamy%20atmosphere%2C%20digital%20art%20in%20warm%20magical%20tones%2C%20clean%20composition%2C%20fantasy%20world%20landscape&width=800&height=600&seq=category-fantasy-01&orientation=landscape',
  },
  {
    id: 'action',
    title: '动作',
    subtitle: '热血沸腾的战斗场面',
    style: 'text',
    icon: 'ri-sword-line',
    image: '',
  },
];

export const userReviews = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20headshot%20portrait%20of%20a%20young%20Asian%20woman%20with%20warm%20smile%2C%20simple%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20and%20friendly%20look%2C%20square%20composition&width=120&height=120&seq=user-avatar-01&orientation=squarish',
    name: '小雨',
    location: '北京 · 大学生',
    title: '画风精美，剧情引人入胜',
    content: '韩漫网的漫画画质真的超级棒！每部作品的画风都特别精美，而且更新速度很快，每天都有新内容可以看，已经成了我每天必刷的网站了。',
    rating: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20headshot%20portrait%20of%20a%20young%20Asian%20man%20with%20friendly%20expression%2C%20simple%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20and%20approachable%20look%2C%20square%20composition&width=120&height=120&seq=user-avatar-02&orientation=squarish',
    name: '阿杰',
    location: '上海 · 设计师',
    title: '分类齐全，找漫超方便',
    content: '作为一个韩漫老粉，这里的分类做得太棒了，恋爱、奇幻、悬疑应有尽有。而且推荐算法很准，总能给我推到我喜欢的类型。',
    rating: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20headshot%20portrait%20of%20a%20young%20Asian%20woman%20with%20gentle%20smile%2C%20simple%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20and%20warm%20look%2C%20square%20composition&width=120&height=120&seq=user-avatar-03&orientation=squarish',
    name: '小鹿',
    location: '广州 · 自由职业',
    title: '免费高清，阅读体验极佳',
    content: '免费还能有这么高清的画质，真的太难得了！阅读器体验也很流畅，翻页丝滑没有任何卡顿，强烈推荐给所有韩漫爱好者。',
    rating: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20headshot%20portrait%20of%20a%20young%20Asian%20man%20with%20confident%20smile%2C%20simple%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20and%20friendly%20look%2C%20square%20composition&width=120&height=120&seq=user-avatar-04&orientation=squarish',
    name: '大熊',
    location: '成都 · 程序员',
    title: '每日必刷，追更神器',
    content: '更新速度快到飞起，热门作品基本都能同步追更。界面简洁清爽没有烦人的广告，用起来特别舒服，已经推荐给身边所有朋友了。',
    rating: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20headshot%20portrait%20of%20a%20young%20Asian%20woman%20with%20bright%20smile%2C%20simple%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20and%20cheerful%20look%2C%20square%20composition&width=120&height=120&seq=user-avatar-05&orientation=squarish',
    name: '喵酱',
    location: '深圳 · 插画师',
    title: '从画风到剧情都是精品',
    content: '作为一个画画的，对画风特别挑剔。韩漫网收录的作品画风质量都很高，很多作品的构图和配色都值得学习，内容质量远超其他平台。',
    rating: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20headshot%20portrait%20of%20a%20young%20Asian%20man%20with%20relaxed%20smile%2C%20simple%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20and%20calm%20look%2C%20square%20composition&width=120&height=120&seq=user-avatar-06&orientation=squarish',
    name: '老陈',
    location: '杭州 · 上班族',
    title: '通勤路上的最佳伴侣',
    content: '每天上下班路上就看韩漫网，加载快画质好，地铁上信号不好也能流畅看。收藏夹功能也很实用，追更管理特别方便。',
    rating: 4,
  },
];

export const ctaData = {
  tag: '加入我们',
  titleLine1: '开启你的',
  titleLine2: '韩漫之旅',
  titleLine3: '从现在开始',
  rightTitleLine1: '发现属于你的',
  rightTitleLine2: '漫画世界',
  description: '无论你喜欢甜蜜的恋爱故事、热血的冒险旅程，还是烧脑的悬疑剧情，韩漫网都为你准备了最丰富的选择。每日更新，高清画质，随时随地享受极致阅读体验。',
  ctaText: '立即浏览漫画库',
  ctaLink: '/category',
};

export const footerData = {
  subscribeTitle: '订阅更新',
  subscribeDesc: '第一时间获取最新漫画上架通知和热门推荐。',
  subscribePlaceholder: '输入您的邮箱地址',
  subscribeButton: '订阅',
  navTitle: '快速导航',
  navLinks: [
    { label: '热门排行', href: '/' },
    { label: '最新上架', href: '/' },
    { label: '全部分类', href: '/category' },
    { label: '关于我们', href: '/about' },
  ],
  contactTitle: '联系我们',
  contactPhone: '400-888-6666',
  contactEmail: 'hello@emenculture.com',
  addressTitle: '公司地址',
  addressLine1: '北京市朝阳区望京SOHO',
  addressLine2: 'T1栋A座18层',
  socialLinks: [
    { label: '微博', href: '#', icon: 'ri-weibo-line' },
    { label: '微信', href: '#', icon: 'ri-wechat-line' },
    { label: 'B站', href: '#', icon: 'ri-bilibili-line' },
  ],
  copyright: '© 2026 韩漫网 HanMan. 保留所有权利。',
  policyLinks: [
    { label: '隐私政策', href: '#' },
    { label: '服务条款', href: '#' },
  ],
};